import { NavigationError } from '@angular/router';

const RELOADED_AT_KEY = 'chunk_reload_at';
const RELOAD_INTERVAL_MS = 60_000;

/**
 * After a deploy, a tab opened before it still asks for the old lazy chunks (their hashed names
 * no longer exist on the server), and the navigation dies. Reload straight into the target URL to
 * pick up the new build: only when online, and at most once a minute so a broken chunk can't loop.
 * Messages: Chrome / Firefox / Safari.
 */
export function reloadOnChunkError(e: NavigationError): void {
  const message = String(e.error?.message ?? e.error);
  if (!/dynamically imported module|Importing a module script failed/i.test(message)) return;
  if (!navigator.onLine) return;
  const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
  if (Date.now() - reloadedAt < RELOAD_INTERVAL_MS) return;
  sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
  location.assign(e.url);
}
